export const getUsersInfos = async (prefix, token) => {
  const url = prefix + "admin/info-users";

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching admin data:", error);
  }
};

export const getOrgsInfos = async (prefix, token) => {
  const url = prefix + "admin/info-orgs";

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching admin data:", error);
  }
};

export const getNumberofFolders = async (prefix, token) => {
  const url = prefix + "admin/total-folders";

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    });
    const data = await response.json();
    return data["Number of folders"];
  } catch (error) {
    console.error("Error fetching admin data:", error);
  }
};

export const getLoggedUsers = async (prefix, token) => {
  const url = prefix + "admin/logged-users";

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching admin data:", error);
  }
};

export const getRequestLogs = async (prefix, token) => {
  const url = prefix + "admin/request-logs";

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching request logs:", error);
  }
};

export const getRequestOnline = async (prefix, token) => {
  const url = prefix + "admin/request-online";

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching request logs:", error);
  }
};

export const getRequestFeedback = async (prefix, token) => {
  const url = prefix + "admin/request-feedback";

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching request logs:", error);
  }
};

export const getFinances = async (prefix, token) => {
  const url = prefix + "admin/finances";

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: headers,
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching admin data:", error);
  }
};
